import { createRoot } from "react-dom/client";
import { GoogleOAuthProvider } from "@react-oauth/google";
import App from "./App";
import "./index.css";

createRoot(document.getElementById("root")!).render(
  <GoogleOAuthProvider clientId="34936497793-qfinpd9t7lhme1d9ocimaeltoetjnv3g.apps.googleusercontent.com">
  <App />
</GoogleOAuthProvider>
);